"use client";
import { ResponsiveImage } from "@/components/Common/ResponsiveImage";
import ImageWrapper from "@/components/ImageWrapper";
import { convertColor, RenderHTML } from "@/helpers/ServerFuncytions";
import { AemHost } from "@/utils/constant";
import { Box } from "@dxp-feed/ui/Box";
import { InnerBannerFull } from "@dxp-feed/ui/InnerBannerFull";
import { Text } from "@dxp-feed/ui/Text";
import React from "react";

const Banner = ({ props } : any) => {
  const currentImage = ResponsiveImage({
    mobileImage: props?.mobileimage,
    tabletImage: props?.tabletimage,
    src: props?.image,
    imagePath: props?.image,
  });

  let textColor = "";
  if (typeof props?.textColor !== "undefined") {
    textColor = convertColor(props?.textColor);
  }

  return (
    <Box as="div" className="">
      {props?.image && (
        
        <Box
          as="div"
          style={
            props?.contentBgImage
              ? {
                  backgroundImage: `url(${AemHost + props?.contentBgImage})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }
              : {
                  backgroundColor: props?.themeBgColor,
                }
          } className="mx-auto max-w-[1920px]"
        >
          <InnerBannerFull
            imageSrc={currentImage}
            imageAlt={props?.imagealt}
            color="transparent"
            className="custom-container-class"
            contentClass="lg:w-[37%] gap-[10px] md:gap-4  p-4 sm:px-3 pt-6 py-6 sm:py-12 mb-2 lg:py-4"
            imageClass="h-[158px] md:h-[270px] lg:h-[350px] [&_img]:object-right 2xl:[&_img]:object-left"
          >
         
            {props?.logoimage && (
              <ImageWrapper
                src={AemHost + props?.logoimage}
                width={212}
                height={64}
                alt={props?.logoimagealt || ""}
              />
            )}
            <Text
              as="h1"
              className="font-raleway text-3xl md:text-5xl lg:text-3xl xl:text-5xl max-w-[440px] sm:max-w-full lg:max-w-[490px]"
              style={{ color: textColor }}
            >
              {props?.title}
            </Text>
            <Text
              as="p"
              className="text-base"
              style={{ color: textColor }}
            >
              {RenderHTML(props?.description)}
              </Text>
          </InnerBannerFull>
        </Box>
      )}
    </Box>
  );
};

export default Banner;
